import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=0dc61c3e&scoped=true&"
import script from "./Datatable.vue?vue&type=script&lang=js&"
export * from "./Datatable.vue?vue&type=script&lang=js&"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=0dc61c3e&prod&scoped=true&lang=css&"
import style1 from "./Datatable.vue?vue&type=style&index=1&id=0dc61c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc61c3e",
  null
  
)

export default component.exports